import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#3126AD",
    d: "M23.845 10.959c-.649-3.144-3.194-4.803-6.24-4.446-1.233.144-2.296.69-3.26 1.446-.836.656-1.513 1.467-2.192 2.273a1 1 0 0 1-.072.076l-.008.008c-.017.015-.032.02-.046.026q-.015.006-.027.007c-.009 0-.018-.005-.027-.007a.14.14 0 0 1-.046-.026l-.008-.007a1 1 0 0 1-.072-.077c-.68-.806-1.356-1.617-2.193-2.273-.964-.756-2.026-1.302-3.259-1.446C3.35 6.156.804 7.814.155 10.959a7.1 7.1 0 0 0 .27 3.905c.847 2.356 2.808 3.7 5.315 3.67 1.527-.017 2.83-.608 4.02-1.51.777-.59 1.442-1.297 2.082-2.027q.038-.044.062-.076c.104-.088.157-.034.254.076.64.73 1.305 1.437 2.082 2.026 1.19.903 2.493 1.494 4.02 1.512 2.507.03 4.469-1.315 5.316-3.671a7.1 7.1 0 0 0 .268-3.905M9.93 12.687c-.412.462-.838.91-1.321 1.3-.802.646-1.67 1.143-2.73 1.24-1.19.111-2.156-.447-2.583-1.526-.147-.374-.209-.764-.211-1.221a3 3 0 0 1 .035-.45c.188-1.498 1.45-2.468 2.946-2.27.784.104 1.432.492 2.042.96.68.52 1.25 1.157 1.837 1.776.078.082.043.126-.015.19M20.703 13.7c-.426 1.08-1.392 1.638-2.583 1.527-1.058-.098-1.927-.595-2.729-1.24-.483-.39-.91-.838-1.322-1.3-.057-.065-.092-.108-.014-.19.587-.62 1.157-1.257 1.837-1.778.61-.467 1.258-.855 2.042-.96 1.495-.197 2.758.772 2.946 2.27.02.169.04.337.036.45-.003.458-.065.848-.213 1.221"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 .5h24v24H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }